import React from "react";
import useTranslationProfile from "../useTranslationProfile.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useMutationProfileDelete from "./useMutationProfileDelete.js";
import useServerErrorFormatter from "../../common/modals/useServerErrorFormatter.js";
import ActionLink from "../../common/widgets/ActionLink.js";
import useFeedbackModal from "../../common/modals/useFeedbackModal.js";
import useDeleteUser from "../../authentication-no-ui/useDeleteUser.js";
import "./ProfileDeleteButton.scss";

export default function ProfileDeleteButton(props) {
  const { employerId } = props;

  const { deleteUser } = useDeleteUser();

  const { t, loading: tLoading } = useTranslationProfile();
  useShowLoader(tLoading, "ProfileDeleteButton");

  const deleteProfile = () => {
    return mutate({
      variables: {
        id: employerId,
      },
    });
  };

  const onCompleted = () => {
    deleteUser();
  };

  const onClickDelete = (event) => {
    event.preventDefault();
    launch(deleteProfile, onCompleted);
  };

  const {
    mutate,
    loading: deleteLoading,
    errors: deleteErrors,
  } = useMutationProfileDelete();
  const successMsg = <p>{t("profile:employers_profile_delete_success_msg")}</p>;
  const errorMsg = useServerErrorFormatter(deleteErrors);
  const confirmMsg = <p>{t("profile:employers_profile_delete_confirm_msg")}</p>;
  const { launch, FeedbackModal } = useFeedbackModal({
    successMsg,
    errorMsg,
    confirmMsg
  });

  return (
    <>
      {FeedbackModal}
      <ActionLink onClick={onClickDelete} loading={deleteLoading}>
        <div className="deleteButton">
          {t("profile:employers_profile_delete_action")}
        </div>
      </ActionLink>
    </>
  );
}
